export const NOT_STARTED = Object.freeze({
	DESCRIPTION: 'Estas entrando a un proceso de carga automática ¿Deseas continuar?',
});
